module.exports = __webpack_public_path__ + "static/media/otp-logo.87ea34cc.png";